const FINDINGS = ["Primary signup action looks disabled", "$0 forever plan says Start free trial"];

export default function HowItWorksFrictionMock() {
  return (
    <div className="max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
      <ul className="divide-y divide-gray-100">
        {FINDINGS.map((title) => (
          <li key={title} className="flex items-start gap-2 px-3 py-2.5">
            <span className="mt-0.5 shrink-0 rounded-md bg-warning-light px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-warning-dark">
              medium
            </span>
            <span className="min-w-0 text-sm font-semibold leading-snug text-gray-900">{title}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
